<div class="flex h-100 justify-center">
    <button (click)="startOver()"
            class="px-5 py-3 m-4 mr-0 font-bold border rounded-lg text-th-primary button border-th-primary hover:bg-th-accent hover:text-th-secondary">
        Start over
    </button>
</div>
